const zh = {
  sinObra: "无项目",
  cat: { materiales: "材料", mano_obra: "人工", subcontratas: "分包", suministros: "水电等供应", fiscal: "税费" },
  rama: {
    albanil_oficial: "技术瓦工", fontanero: "水管工", electricista: "电工", carpinteria_madera: "木工",
    carpintero_aluminio: "铝材门窗工", gestion_residuos: "废料处理", transportes: "运输",
    peones: "普工 / 帮工", gestiones_comerciales: "商务事务",
  },
  exento: { si: "免税", marcar: "标记为免税", marcado: "支出已标记为免税", quitado: "已取消免税标记", error: "无法更新该支出" },
  toast: {
    subida: "图片已上传", leyendo: "图片已上传 · 正在读取发票数据…", leidos: "已自动读取发票数据 ✨",
    noLeidos: "无法自动读取数据，请手动填写。", errorSubir: "无法上传图片",
    registrado: "支出已保存", eliminado: "支出已删除",
  },
  jornada: {
    titulo: "各工程工时（上限每周 {{n}} 小时）", totales: "共 {{n}} 小时",
    excesoObras: "{{n}} 个工程", excesoTexto: "每周人工超过 {{n}} 小时。请检查工作量。",
    vacio: "尚未登记人工工时。请添加「人工」类别的支出，并填写工程和工时。",
    semExcedidas: "{{n}} 周超时", resumen: "{{h}} 小时 · {{n}} 周", excesoSemana: "超出 {{n}} 小时法定上限 {{h}} 小时。",
  },
  coste: { titulo: "各工程成本", ver: "查看工程 / 项目 →", obra: "工程", materiales: "材料", manoObra: "人工", total: "总成本" },
  vacio: { titulo: "暂无支出", hint: "登记材料、人工和分包的发票" },
  tabla: { concepto: "说明", categoria: "类别", fecha: "日期", horas: "工时", total: "合计", justificante: "凭证", justificanteM: "凭证" },
  form: {
    escanea: "扫描发票，我们帮您填写数据", quitar: "移除图片", leyendo: "正在读取…", camara: "用相机扫描",
    subir: "上传文件", analizando: "正在分析图片…",
    ocrBloqueado: "您可以附上图片；AI 自动读取从季度套餐起可用。",
    concepto: "说明", categoria: "类别", proveedor: "供应商 / 公司", base: "税前金额（€）", impuesto: "税种",
    obra: "工程 / 项目", irpf: "IRPF 预扣（专业人士）", sinRetencion: "不预扣",
    isp: "反向征收", ispNota: "（工程分包商开具不含增值税或 IGIC 的发票）",
    exento: "免税", exentoNota: "（保险、规费、住房租金…）",
    horas: "工时", rama: "工种", datosFactura: "发票信息", numero: "发票号", hora: "购买时间",
    nif: "公司 NIF / CIF", registro: "商业登记号", opcional: "选填", fecha: "日期",
  },
};

export default zh;
